import {ScrollLock} from '../utils/scroll-lock';
import animate from '../utils/animate';

const DASHARRAY = 1097;

const preloader = document.querySelector('.preloader');
let scrollLock;
let callback = false;

const hidePreloader = () => {
  if (!preloader) {
    return;
  }

  preloader.classList.add('is-hidden');
  scrollLock.enableScrolling();

  if (callback) {
    setTimeout(callback, 300);
  }
};

const animateLoader = (progress) => {
  if (!preloader) {
    return;
  }

  const counter = preloader.querySelector('.preloader__progress-counter');
  const circle = preloader.querySelector('.preloader__circle-animate');

  if (!counter && !circle) {
    return;
  }

  let percent = Math.round(progress * 100);
  percent = percent < 0 ? 0 : percent;
  percent = percent > 100 ? 100 : percent;
  const dash = DASHARRAY - Math.round(DASHARRAY * (percent / 100));

  counter.textContent = percent;
  circle.style.strokeDashoffset = dash;
};

const initPreloader = (cb) => {
  if (!preloader) {
    return;
  }

  if (cb) {
    callback = cb;
  }

  scrollLock = new ScrollLock();
  scrollLock.disableScrolling();

  animate(2000, animateLoader, hidePreloader);
};

export {initPreloader};
